/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fond_Kind_Newt_FlowInputs */

const en_fond_kind_newt_flow = /** @type {(inputs: Fond_Kind_Newt_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label`)
};

const de_fond_kind_newt_flow = /** @type {(inputs: Fond_Kind_Newt_FlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezeichnung`)
};

/**
* | output |
* | --- |
* | "Label" |
*
* @param {Fond_Kind_Newt_FlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fond_kind_newt_flow = /** @type {((inputs?: Fond_Kind_Newt_FlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fond_Kind_Newt_FlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fond_kind_newt_flow(inputs)
	return de_fond_kind_newt_flow(inputs)
});